import $ from 'jquery';
import Swiper from 'swiper';
// L'entree principale "swiper" n'exporte que la classe Swiper elle-meme -
// Navigation/Pagination/Autoplay doivent venir du sous-chemin "swiper/modules"
// (sinon ce sont des imports undefined, d'ou le "mod is not a function" leve
// par Swiper des qu'on les passe dans modules: [...]).
import {Navigation, Pagination, Autoplay} from 'swiper/modules';

/**
 * Initialise un Swiper avec des paramètres personnalisables.
 *
 * @param {string} container - Le sélecteur CSS du conteneur Swiper.
 * @param {Object} options - Les options de configuration pour Swiper.
 * @param {boolean} [options.loop=false] - Activer/désactiver la boucle.
 * @param {number} [options.slidesPerView=1] - Nombre de slides visibles.
 * @param {Object} [options.breakpoints] - Configuration des slides par breakpoint.
 * @param {boolean} [options.navigation=false] - Activer/désactiver la navigation (next/prev).
 * @param {Object} [options.navigationEls] - Selecteurs CSS externes {nextEl, prevEl} (ex. des boutons
 *   places hors du conteneur, alignes avec un titre) ; sinon les boutons internes par defaut sont utilises.
 * @param {boolean} [options.autoplay=false] - Activer/désactiver l'autoplay.
 * @param {string} [options.wrapperClass] - Classe wrapper personnalisee (au lieu de "swiper-wrapper").
 * @param {string} [options.slideClass] - Classe slide personnalisee (au lieu de "swiper-slide").
 * @returns {Swiper} - Instance Swiper initialisée.
 */
function initSwiper(container, {
    loop = false,
    slidesPerView = 1,
    spaceBetween = 20,
    breakpoints = {},
    navigation = false,
    navigationEls = null,
	pagination = false,
	paginationEl = null,
	autoplay = false,
	autoplayDelay = 3000,
	speed = null,
	autoHeight=false,
	watchOverflow = true,
	centeredSlides = false,
	slideToClickedSlide = false,
	wrapperClass = null,
	slideClass = null,
} = {}) {
	const config = {
		modules: [Navigation, Pagination, Autoplay],
		loop,
		spaceBetween,
		slidesPerView,
		breakpoints,
		autoHeight,
		watchOverflow,
		centeredSlides,
		slideToClickedSlide,
		observer: true,
		observeParents: true,
		updateOnWindowResize: true,
	};

	// Classes wrapper/slide personnalisees (au lieu des defauts Swiper
	// "swiper-wrapper"/"swiper-slide") - utile pour reutiliser un balisage
	// existant deja habille pour un layout desktop different (grille
	// Bootstrap, etc.) sans que le CSS de base de Swiper (globalement
	// applique a ces classes, meme sans JS) ne l'ecrase.
	if (wrapperClass) {
		config.wrapperClass = wrapperClass;
	}
	if (slideClass) {
		config.slideClass = slideClass;
	}

    if (navigation) {
        config.navigation = navigationEls ? {
            nextEl: navigationEls.nextEl,
            prevEl: navigationEls.prevEl,
        } : {
            nextEl: `${container} .swiper-button-next`,
            prevEl: `${container} .swiper-button-prev`,
        };
    }

	if (pagination) {
		config.pagination = {
			el: paginationEl || `${container} .swiper-pagination`,
			clickable: true,
		};
	}

    if (autoplay) {
        config.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
        };
    }

    if (speed !== null) {
        config.speed = speed;
    }

    if (Object.keys(breakpoints).length > 0) {
		config.breakpoints = breakpoints;
    }

    return new Swiper(container, config);
}

export default initSwiper;
